import { ReactNode, useId, useState } from 'react';

type PasswordFieldProps = {
  label: ReactNode;
  value: string;
  onChange: (value: string) => void;
  autoComplete?: string;
  required?: boolean;
  autoFocus?: boolean;
  hint?: ReactNode;
};

/** Password input with a show/hide toggle, styled to match .auth-form. */
export function PasswordField({ label, value, onChange, autoComplete, required = true, autoFocus, hint }: PasswordFieldProps) {
  const [visible, setVisible] = useState(false);
  const id = useId();
  return <label htmlFor={id}>
    {label}
    <span className="password-field-control">
      <input
        id={id}
        type={visible ? 'text' : 'password'}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        autoComplete={autoComplete}
        required={required}
        autoFocus={autoFocus}
      />
      <button type="button" className="password-toggle" onClick={() => setVisible((current) => !current)} aria-label={visible ? 'Ocultar contraseña' : 'Mostrar contraseña'}>
        {visible ? 'Ocultar' : 'Mostrar'}
      </button>
    </span>
    {hint}
  </label>;
}
